import { render } from "./ProcessPanel.vue?vue&type=template&id=f4afd10a&scoped=true"
import script from "./ProcessPanel.vue?vue&type=script&lang=js"
export * from "./ProcessPanel.vue?vue&type=script&lang=js"

import "./ProcessPanel.vue?vue&type=style&index=0&id=f4afd10a&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4afd10a"]])

export default __exports__